/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Reports constructor Translation
 *
 * @author Evgeniy Naumov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { IPageReportsConstructorTranslation } from '@modules/internationalization/types/pages/reportsConstructor';

export const initPageReportsConstructorTranslation: IPageReportsConstructorTranslation = {
    header: {
        title: '',
        basket: {
            selected: '',
            subscribers: '',
            changeLinkTitle: '',
        },
    },
    common: {
        titles: {
            newReports: '',
            additionalReports: '',
            reportTemplates: '',
        },
        schedule: '',
        created: '',
        menu: {
            edit: '',
            rename: '',
            delete: '',
        },
    },
    footer: {
        createTemplate: '',
        orederReport: '',
        orderList: '',
        tooltip: {
            selectReport: '',
            selectSubs: '',
            templateWithAdditionalReport: '',
            templateWithTemplateReport: '',
        },
    },
    newReports: {
        REPORT_CUSTOM_SUBSCRIBERS: {
            title: '',
            description: '',
        },
        REPORT_CUSTOM_TARIFFS: {
            title: '',
            description: '',
        },
        REPORT_CUSTOM_CORP_CLIENTS: {
            title: '',
            description: '',
        },
    },
    additionalReports: {
        REPORT_SUBSCRIBERS_WITH_LIMITS: {
            title: '',
            description: '',
        },
        REPORT_SUBSCRIBERS_WITH_MIN_LIMITS: {
            title: '',
            description: '',
        },
        REPORT_SUBSCRIBERS_WITH_PARAMETERS: {
            title: '',
            description: '',
        },
        REPORT_SUBSCRIBERS_WITH_BLOCK: {
            title: '',
            description: '',
        },
        REPORT_SUBSCRIBERS_NEW: {
            title: '',
            description: '',
        },
        REPORT_SUBSCRIBERS_WITH_STATIC_IP: {
            title: '',
            description: '',
        },
    },
    reportTemplates: {
        REPORT_CUSTOM_SUBSCRIBERS: {
            typeDescription: '',
        },
        REPORT_CUSTOM_TARIFFS: {
            typeDescription: '',
        },
        REPORT_CUSTOM_CORP_CLIENTS: {
            typeDescription: '',
        },
    },
    start: {
        fields: {
            templateName: {
                label: '',
                placeholder: '',
                prompt: '',
            },
        },
        renameTemplateModalTitle: '',
        saveTemplateModalTitle: '',
        removeTemplateModalTitle: '',
        removeTemplateModalText: '',
    },
    success: {
        renameTemplateModalTitle: '',
        renameTemplateModalText: '',
        removeTemplateModalTitle: '',
    },
    failure: {
        renameTemplateModalTitle: '',
        removeScheduleModalTitle: '',
        removeTemplateModalTitle: '',
    },
    scheduleTable: {
        description: '',
        orderAttrType: '',
        periodType: '',
        reportFormat: '',
        report: '',
        startTime: '',
        remove: '',
        modalRemoveMessage: '',
    },
    pageSettingsAutoReportsLink: '',
};
